<template>
	<vxe-modal v-model="modal" width="500" height="auto" @show="show" @hdie="hide" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="splitform" :model="form" label-width="60px" size="mini">
				<el-form-item label="归属人" class="item">
					<staff v-model="form.staffid" @modalsubmit="staffchange" />
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style>

</style>
<style scoped>
	.item {
		margin-bottom: 4px;
	}
</style>
<script>
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		name: 'customerDistributionIndex',
		props: {
			customerids: {
				type: Array,
				default: () => {
					return []
				}
			},
			title: {
				type: String,
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				form: {
					staffid: null,
				}
			}
		},
		watch: {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			submit() {
				if (!this.form.staffid) {
					this.$message.error('分配人不能为空')
					return false
				} else {
					let obj = {
						staffid: this.form.staffid,
						customerids:this.customerids
					}
					this.$api.crmcustomer.distribution(obj).then(() => {
						this.$message.success('操作成功')
						this.$emit('submit')
					})
				}
			},
			staffchange(e) {
				this.form.staffid = e.data
			},
			modalShow() {
				this.modal = true
			},
			modalHide() {
				this.modal = false
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.form = {
					staffid: null
				}
				this.$emit('hide')
			},
			show() {

			},
		},
		components: {
			staff
		}
	}
</script>